import moment from "moment";
import HelperMixin from "../../../Shared/HelperMixin.vue";
import PaginationHelper from "../../../Shared/PaginationHelper.vue";

export default {
    name: "WalletPurchases",
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
        await this.GetAllUsers();
    },

    filters: {
        moment: function (date) {
            if (!date) return "—";
            return moment(date).format("DD/MM/YYYY");
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,

            ScreenTitle: "حركات الدفع (مشتريات المحفظة)",
            ScreenTitleSingle: "حركة",

            Info: [],
            Statistics: 0,

            Search: "",
            From: "",
            To: "",

            WalletId: 0,
            UserId: 0,
            IsSubscription: null,        // اللي يروح للـ API (bool?)
            // ...
            IsSubscriptionCheck: false,  // للـ checkbox فقط
        };
    },

    methods: {
        onIsSubscriptionChange() {
            // ✅ لو مفعّل => true (اشتراكات فقط)
            // ✅ لو مطفي => null (الكل)
            this.IsSubscription = this.IsSubscriptionCheck ? true : null;
            this.GetInfo(1);
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;

            let from = this.From ? this.ChangeDate(this.From) : null;
            let to = this.To ? this.ChangeDate(this.To) : null;

            if (!this.Search) this.$blockUI.Start();

            this.$http
                .GetWalletPurchases(
                    this.pageNo,
                    this.pageSize,
                    this.Search,
                    from,
                    to,
                    Number(this.WalletId || 0),
                    Number(this.UserId || 0),
                    this.IsSubscription
                )
                .then((response) => {
                    if (!this.Search) this.$blockUI.Stop();

                    const data = response.data || {};
                    this.Info = data.info || [];
                    this.pages = data.count || 0;

                    const s = data.statistics || {};
                    // API C# غالباً PascalCase
                    this.Statistics = {
                        count: s.count ?? s.Count ?? 0,
                        totalValue: s.totalValue ?? s.TotalValue ?? 0,
                        totalCoursePrice: s.totalCoursePrice ?? s.TotalCoursePrice ?? 0,
                        bySubscription: s.bySubscription ?? s.BySubscription ?? 0,
                        byTrip: s.byTrip ?? s.ByTrip ?? 0
                    };
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = 0;
                });
        },

        Refresh() {
            this.Search = "";
            this.From = "";
            this.To = "";
            this.WalletId = 0;
            this.UserId = 0;
            this.IsSubscription = null;
            this.GetInfo(1);
        }
    }
};